// Import placeholder images - these should be replaced with actual delivered project images
import gcv1Dubai from '../images/projects/delivered-projects/gc-views-1-dubai.jpg'
import gcv2Dubai from '../images/projects/delivered-projects/gc-views-2-dubai.jpg'
import gceExecutiveDubai from '../images/projects/delivered-projects/gcv-exective-dubai.jpg'
import canyonViews from '../images/projects/delivered-projects/canyon-views.jpg'
import crescentBay from '../images/projects/delivered-projects/cresent-bay-land-reclamation.jpg'
import defenceResidency from '../images/projects/delivered-projects/defence-resedency.jpg'
import gigaBoutique from '../images/projects/delivered-projects/giga-boutique-mall.jpg'
import elCielo from '../images/projects/delivered-projects/elcielo-1-and-2.jpg'
import lignumTower from '../images/projects/delivered-projects/lignum-tower.jpg'
import wtc from '../images/projects/delivered-projects/gm-wtc.jpg'
import pearlRecidency from '../images/projects/delivered-projects/pearl-residency.jpg'
import alNajeebiBazaar from '../images/projects/delivered-projects/al-najeebi-bazaar.jpg'
import gcSouqLahore from '../images/projects/delivered-projects/gc-souq-lahore.jpg'

const DeliveredProjects = [
    {
        Id: '1',
        pImg: gcv1Dubai,
        title: 'Goldcrest Views 1, Dubai',
        subTitle: 'Dubai',
        description: 'Goldcrest Views 1 is a 40-storey residential tower in JLT Cluster V, developed by Al Ghurair Group. It offers 376 ready units, from studios to penthouses, with top-tier amenities like a rooftop pool, gym, sauna, and sports bar. Located near metro stations, Dubai Marina, and Palm Jumeirah, it promises a luxurious yet convenient lifestyle.',
    },
    {
        Id: '2',
        pImg: gcv2Dubai,
        title: 'Goldcrest Views 2, Dubai',
        subTitle: 'Dubai',
        description: 'Goldcrest Views 2 is a thirty-nine-story tower that offers a variety of freehold apartments and offices located in Jumeirah Lakes Towers, Dubai. The Tower, designed around a rectangular plan, offers a spectacular lakeside and island view from the apartments on all levels. The building has a bold, contemporary style with strong visual elements. The project has been completed and delivered.',
    },
    {
        Id: '3',
        pImg: gceExecutiveDubai,
        title: 'Goldcrest Executive, Dubai',
        subTitle: 'Dubai',
        description: 'Goldcrest Executive is a 40-storey mixed-use tower in JLT, developed by Giga Group. It features offices on the lower 20 floors and residential studios and 1-bed apartments above. With top amenities like a gym, pool, high-speed elevators, and 24/7 security, it offers modern living and working spaces in Dubai\'s vibrant freehold community.',
    },
    {
        Id: '4',
        pImg: canyonViews,
        title: 'Canyon Views, DHA Islamabad',
        subTitle: 'DHA Islamabad',
        description: 'Giga Group, in collaboration with Emaar, started residential projects spread over an area of 386 acres in DHA Islamabad Phase II Extension. The project is named Emaar Canyon Views, Islamabad. It comprises modern luxury villas and townhouses. The first phase of development has been completed, and villas are successfully handed over to the customers.',
    },
    {
        Id: '5',
        pImg: crescentBay,
        title: 'Crescent Bay, DHA Karachi',
        subTitle: 'DHA Karachi',
        description: 'The Group partnered with Dubai\'s Emaar Properties to launch CrescentBay, a groundbreaking 108-acre sea-reclaimed project in DHA Phase VIII, Karachi. This modern development includes high- and mid-rise residential and commercial towers, a shopping center, and a five-star beachfront hotel. Located near the DHA golf course, CrescentBay marks a significant milestone in Pakistan\'s real estate landscape.',
    },
    {
        Id: '6',
        pImg: defenceResidency,
        title: 'Defence Residency, DHA Islamabad',
        subTitle: 'DHA Islamabad',
        description: 'Defense Residency is a low-rise residential project comprising 2, 3, 4, and 5-room executive apartments located in DHA Phase-II on the Main G.T. Road in Islamabad. The project includes 17 buildings with over 1,400 apartments. It offers modern amenities and caters to various family setups from middle and upper-class strata.',
    },
    {
        Id: '7',
        pImg: gigaBoutique,
        title: 'Giga Boutique Mall, Islamabad',
        subTitle: 'Islamabad',
        description: 'Giga Boutique Mall, Islamabad\'s newest, hippest mall! Giga West brings you the first water park of its kind in any mall in the Twin Cities. Located right next to Giga Mall in DHA, it features water slides and entertainment for all ages. Combining modern architecture with a variety of shopping and leisure options, it\'s a landmark development.',
    },
    {
        Id: '8',
        pImg: elCielo,
        title: 'El Cielo I and II Apartments, Islamabad',
        subTitle: 'Islamabad',
        description: 'El Cielo is a luxury residential development in DHA II, Islamabad, consisting of two 12-floor towers with 320 apartments. The development includes three categories—premium, premium plus, and executive apartments. It is set to be handed over soon, continuing Giga\'s tradition of luxurious and secure residential projects.',
    },
    {
        Id: '9',
        pImg: lignumTower,
        title: 'Lignum Tower, Islamabad',
        subTitle: 'Islamabad',
        description: 'Lignum Tower in DHA Phase 2, Giga City, Islamabad, offers stylish high-rise and terrace apartments designed for modern professionals. Featuring spacious dining rooms, ultra-modern kitchens, airy bedrooms, and luxury bathrooms, it blends elegance with comfort. Amenities include dedicated parking, CCTV security, intercom access, swift elevators, and 24/7 power backup, delivering a premium urban living experience.',
    },
    {
        Id: '10',
        pImg: wtc,
        title: 'Giga Mall, Islamabad',
        subTitle: 'Islamabad',
        description: 'Giga Mall in Islamabad is a premier five-floor shopping destination by Giga Group, featuring over 200 local and international stores, dining, and entertainment. It offers modern amenities like spacious parking, Wi-Fi, banking services, prayer rooms, and accessibility features, serving both Islamabad and Rawalpindi.'
    },
    {
        Id: '11',
        pImg: pearlRecidency,
        title: 'Pearl Residency, Karachi',
        subTitle: 'Karachi',
        description: 'Pearl Residency consists of two state-of-the-art high-rise residential towers situated behind Aga Khan Hospital in Block 14 of Gulshan-e-Iqbal, Karachi. It is near the Civic Centre and Expo Centre. The project is fully completed.'
    },
    {
        Id: '12',
        pImg: alNajeebiBazaar,
        title: 'Al Najeebi Bazaar, Karimabad Karachi',
        subTitle: 'Karimabad Karachi',
        description: 'Al Najeebi Bazaar Karimabad is located at Shahra-e-Pakistan, Main Karimabad, Karachi. The 1511 square yards project features 475 shops (100,000 sq ft) and is fully completed and operational.'
    },
    {
        Id: '13',
        pImg: gcSouqLahore,
        title: 'Goldcrest Souq, Lahore',
        subTitle: 'Lahore',
        description: 'Goldcrest Souq in Sector DD, Phase IV of DHA Lahore is a modern commercial tower featuring shops and offices. Once complete, it will include 4 basements and a ground plus 13-floor structure. The project is currently in its initial development phase and construction has started.'
    }
]
export default DeliveredProjects;
